interface Options {
  crossOrigin: HTMLImageElement["crossOrigin"];
}

export async function loadImage(
  url: string,
  options?: Options,
): Promise<HTMLImageElement | null> {
  try {
    return await load(url, options);
  } catch (error) {
    console.error(error);

    return null;
  }
}

function load(
  url: string,
  options?: Options,
): Promise<HTMLImageElement | never> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image), { once: true });
    image.addEventListener("error", (error) => reject(error), { once: true });

    if (options?.crossOrigin) {
      image.crossOrigin = options.crossOrigin;
    }

    image.src = url;
  });
}
